<template>
  <b-row>
    <b-col :cols="dateColWidth">
      <BfDatePicker
        :value="data.fecha_hora_ini"
        label="Fecha y hora"
        data-key="fecha_hora_ini"
        :bottom-gutter="false"
        :type="dateFieldType"
        :format="dateFieldFormat"
        value-format="yyyy-MM-dd HH:mm:ss"
        @update="updateForm"
      />
    </b-col>

    <b-col
      v-if="seperateTimeField"
      :cols="timeColWidth"
    >
      <TimePicker
        v-model="timeFieldValue"
        class="visit-time-field"
        format="HH:mm"
        value-format="HH:mm:ss"
        @change="updateTimeField($event)"
      />
    </b-col>

   <!-- <b-col :cols="durationColWidth">
      <BfInput
        :value="data.duration"
        prefix-icon="el-icon-time"
        label="Duración"
        data-key="duration"
        :bottom-gutter="false"
        type="number"
        @update="updateForm"
      />
    </b-col> -->
    <slot></slot>
  </b-row>
</template>

<script>
import { TimePicker } from 'element-ui';

export default {
  name: 'ScheduleVisitForm',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    dateColWidth: {
      type: Number,
      default: 3,
    },

    durationColWidth: {
      type: Number,
      default: 2,
    },

    seperateTimeField: {
      type: Boolean,
      default: false,
    },

    timeColWidth: {
      type: Number,
      default: 3,
    },
  },

  data() {
    return {
      timeFieldValue: '',
    };
  },

  methods: {
    updateForm(fieldData) {
      this.$emit('update', fieldData);
    },

    updateTimeField(value) {
      this.updateForm({
        key: 'startTime',
        value,
      });
    },
  },

  computed: {
    dateFieldType() {
      return !this.seperateTimeField ? 'datetime' : 'date';
    },

    dateFieldFormat() {
      return !this.seperateTimeField ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy';
    },
  },

  watch: {
    timeFieldValue(newTime, prevTime) {
      if (newTime !== prevTime) {
        this.updateTimeField(newTime);
      }
    },
  },

  components: {
    TimePicker,
  },
};
</script>

<style lang="scss" scoped>
.visit-time-field {
  margin-top: 30px;
  max-width: 100%;
}
</style>
